export default "__VITE_ASSET__BhpaMCyO__"